export default __webpack_public_path__ + "static/media/file-icon-dark-custom.c91670af.svg";